<script setup>
import { ref, watch, computed } from 'vue';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';

const props = defineProps({
  visible: Boolean,
  mode: {
    type: String,
    default: 'create', // 'create' | 'edit'
    validator: (value) => ['create', 'edit'].includes(value)
  },
  itemType: {
    type: Object,
    default: null
  },
  // 'document' или 'file'
  entityType: {
    type: String,
    required: true,
    validator: (value) => ['document', 'file'].includes(value)
  }
});

const emit = defineEmits(['update:visible', 'save', 'close']);

const form = ref({
  name: ''
});

const isEdit = computed(() => props.mode === 'edit');
const dialogTitle = computed(() => {
  const typeLabel = props.entityType === 'document' ? 'тип документа' : 'тип файла';
  return isEdit.value ? `Редактировать ${typeLabel}` : `Создать ${typeLabel}`;
});

watch(() => props.visible, (newVal) => {
  if (newVal) {
    if (isEdit.value && props.itemType) {
      form.value = {
        name: props.itemType.item_name || props.itemType.name || ''
      };
    } else {
      resetForm();
    }
  }
});

function resetForm() {
  form.value = {
    name: ''
  };
}

function handleSave() {
  if (!form.value.name.trim()) {
    return;
  }

  const payload = {
    item_name: form.value.name.trim(),
    for_document_kind: props.entityType === 'document',
    for_file_kind: props.entityType === 'file',
    role_ids: props.itemType?.role_ids || []
  };

  emit('save', payload);
}

function handleClose() {
  emit('update:visible', false);
  emit('close');
  resetForm();
}
</script>

<template>
  <Dialog
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    :header="dialogTitle"
    modal
    :style="{ width: '500px' }"
  >
    <div class="flex flex-col gap-4">
      <!-- Название -->
      <div class="flex flex-col gap-2">
        <label for="item-name" class="font-semibold">
          Название <span class="text-red-500">*</span>
        </label>
        <InputText
          id="item-name"
          v-model="form.name"
          :placeholder="entityType === 'document' ? 'Введите название типа документа' : 'Введите название типа файла'"
          class="w-full"
          autofocus
        />
      </div>
    </div>

    <template #footer>
      <div class="flex justify-end gap-2">
        <Button label="Отмена" severity="secondary" @click="handleClose" rounded size="small" />
        <Button
          :label="isEdit ? 'Сохранить' : 'Создать'"
          severity="info"
          @click="handleSave"
          rounded
          size="small"
          :disabled="!form.name.trim()"
        />
      </div>
    </template>
  </Dialog>
</template>

<style scoped>
</style>
